/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitProfileExtensionEnum } from './PressKitProfileExtensionEnum';
import {
    PressKitProfileExtensionEnumFromJSON,
    PressKitProfileExtensionEnumFromJSONTyped,
    PressKitProfileExtensionEnumToJSON,
} from './PressKitProfileExtensionEnum';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';

/**
 * 
 * @export
 * @interface PostPressKitBodyProfilesInner
 */
export interface PostPressKitBodyProfilesInner {
    /**
     * エラー箇所を特定するために必要な各オブジェクトのID
     * @type {string}
     * @memberof PostPressKitBodyProfilesInner
     */
    objectId: string;
    /**
     * 既存画像のUUID。空文字だと新規作成される。
     * @type {string}
     * @memberof PostPressKitBodyProfilesInner
     */
    id?: string;
    /**
     * プロフィール画像のファイルリソースが保存されたS3のURL、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PostPressKitBodyProfilesInner
     */
    resourceUri?: string;
    /**
     * 
     * @type {PressKitProfileExtensionEnum}
     * @memberof PostPressKitBodyProfilesInner
     */
    extension?: PressKitProfileExtensionEnum;
    /**
     * 企業が登録したプロフィールの名前
     * @type {string}
     * @memberof PostPressKitBodyProfilesInner
     */
    name: string;
    /**
     * 企業が登録したプロフィールの名前のよみがな（発音）
     * @type {string}
     * @memberof PostPressKitBodyProfilesInner
     */
    nameKana: string;
    /**
     * ファイルのサイズ（単位はbytes）。resource_uri変更時だけ変更可能。
     * @type {number}
     * @memberof PostPressKitBodyProfilesInner
     */
    fileSize?: number;
    /**
     * 企業が登録したプロフィールの役職
     * @type {string}
     * @memberof PostPressKitBodyProfilesInner
     */
    title: string;
    /**
     * 企業が登録したプロフィール文
     * @type {string}
     * @memberof PostPressKitBodyProfilesInner
     */
    description: string;
    /**
     * ラスター画像の幅。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PostPressKitBodyProfilesInner
     */
    imageWidth: number;
    /**
     * ラスター画像の高さ。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PostPressKitBodyProfilesInner
     */
    imageHeight: number;
    /**
     * 
     * @type {Array<PressKitTag>}
     * @memberof PostPressKitBodyProfilesInner
     */
    tags: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PostPressKitBodyProfilesInner interface.
 */
export function instanceOfPostPressKitBodyProfilesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "nameKana" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "imageWidth" in value;
    isInstance = isInstance && "imageHeight" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PostPressKitBodyProfilesInnerFromJSON(json: any): PostPressKitBodyProfilesInner {
    return PostPressKitBodyProfilesInnerFromJSONTyped(json, false);
}

export function PostPressKitBodyProfilesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBodyProfilesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectId': json['__object_id'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'resourceUri': !exists(json, 'resource_uri') ? undefined : json['resource_uri'],
        'extension': !exists(json, 'extension') ? undefined : PressKitProfileExtensionEnumFromJSON(json['extension']),
        'name': json['name'],
        'nameKana': json['name_kana'],
        'fileSize': !exists(json, 'file_size') ? undefined : json['file_size'],
        'title': json['title'],
        'description': json['description'],
        'imageWidth': json['image_width'],
        'imageHeight': json['image_height'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PostPressKitBodyProfilesInnerToJSON(value?: PostPressKitBodyProfilesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '__object_id': value.objectId,
        'id': value.id,
        'resource_uri': value.resourceUri,
        'extension': PressKitProfileExtensionEnumToJSON(value.extension),
        'name': value.name,
        'name_kana': value.nameKana,
        'file_size': value.fileSize,
        'title': value.title,
        'description': value.description,
        'image_width': value.imageWidth,
        'image_height': value.imageHeight,
        'tags': ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

